export default __webpack_public_path__ + "f822e72de348ba134549743c38a849e3.svg";